import { Button } from '@mui/material';
import { styled } from '@mui/system';
import theme from '../../../../theme';
import { ApprovalStatuses } from './InitialReviewProcedureItem';

type StyledButtonProps = {
    approvalstatus: string | null;
    isnew: string;
};

const StyledButtonApprove = styled(Button)(({ approvalstatus, isnew }: StyledButtonProps) => ({
    borderRadius: '8px',
    border: '1px solid',
    // If the case procedure code is new, nothing is selected
    borderColor: (isnew === 'true' ? true : false)
        ? theme.palette.cardSubtitle.main
        : approvalstatus === ApprovalStatuses.Approved
        ? theme.palette.secondary.dark
        : theme.palette.cardSubtitle.main,
    color: (isnew === 'true' ? true : false)
        ? theme.palette.cardSubtitle.main
        : approvalstatus === ApprovalStatuses.Approved
        ? 'white'
        : theme.palette.cardSubtitle.main,
    background: (isnew === 'true' ? true : false)
        ? 'white'
        : approvalstatus === ApprovalStatuses.Approved
        ? theme.palette.secondary.dark
        : 'white',
    '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        color: 'white'
    },
    ':disabled': {
        color: (isnew === 'true' ? true : false)
            ? theme.palette.cardSubtitle.main
            : approvalstatus === ApprovalStatuses.Approved
            ? 'white'
            : theme.palette.cardSubtitle.main
    }
}));

const StyledButtonPartialApprove = styled(Button)(
    ({ approvalstatus, isnew }: StyledButtonProps) => ({
        borderRadius: '8px',
        border: '1px solid',
        // If the case procedure code is new, nothing is selected
        borderColor: (isnew === 'true' ? true : false)
            ? theme.palette.cardSubtitle.main
            : approvalstatus === ApprovalStatuses.PartiallyApproved
            ? theme.palette.secondary.dark
            : theme.palette.cardSubtitle.main,
        color: (isnew === 'true' ? true : false)
            ? theme.palette.cardSubtitle.main
            : approvalstatus === ApprovalStatuses.PartiallyApproved
            ? 'white'
            : theme.palette.cardSubtitle.main,
        background: (isnew === 'true' ? true : false)
            ? 'white'
            : approvalstatus === ApprovalStatuses.PartiallyApproved
            ? theme.palette.secondary.dark
            : 'white',
        '&:hover': {
            backgroundColor: theme.palette.secondary.dark,
            color: 'white'
        },
        ':disabled': {
            color: (isnew === 'true' ? true : false)
                ? theme.palette.cardSubtitle.main
                : approvalstatus === ApprovalStatuses.PartiallyApproved
                ? 'white'
                : theme.palette.cardSubtitle.main
        }
    })
);

const StyledButtonDeny = styled(Button)(({ approvalstatus, isnew }: StyledButtonProps) => ({
    borderRadius: '8px',
    border: '1px solid',
    // If the case procedure code is new, nothing is selected
    borderColor: (isnew === 'true' ? true : false)
        ? theme.palette.cardSubtitle.main
        : approvalstatus === ApprovalStatuses.Denied
        ? theme.palette.secondary.dark
        : theme.palette.cardSubtitle.main,
    color: (isnew === 'true' ? true : false)
        ? theme.palette.cardSubtitle.main
        : approvalstatus === ApprovalStatuses.Denied
        ? 'white'
        : theme.palette.cardSubtitle.main,
    background: (isnew === 'true' ? true : false)
        ? 'white'
        : approvalstatus === ApprovalStatuses.Denied
        ? theme.palette.secondary.dark
        : 'white',
    '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        color: 'white'
    },
    ':disabled': {
        color: (isnew === 'true' ? true : false)
            ? theme.palette.cardSubtitle.main
            : approvalstatus === ApprovalStatuses.Denied
            ? 'white'
            : theme.palette.cardSubtitle.main
    }
}));

const StyledButtonNoReviewRequired = styled(Button)(
    ({ approvalstatus, isnew }: StyledButtonProps) => ({
        borderRadius: '8px',
        border: '1px solid',
        // If the case procedure code is new, nothing is selected
        borderColor: (isnew === 'true' ? true : false)
            ? theme.palette.cardSubtitle.main
            : approvalstatus === ApprovalStatuses.NoReviewRequired
            ? theme.palette.secondary.dark
            : theme.palette.cardSubtitle.main,
        color: (isnew === 'true' ? true : false)
            ? theme.palette.cardSubtitle.main
            : approvalstatus === ApprovalStatuses.NoReviewRequired
            ? 'white'
            : theme.palette.cardSubtitle.main,
        background: (isnew === 'true' ? true : false)
            ? 'white'
            : approvalstatus === ApprovalStatuses.NoReviewRequired
            ? theme.palette.secondary.dark
            : 'white',
        '&:hover': {
            backgroundColor: theme.palette.secondary.dark,
            color: 'white'
        },
        ':disabled': {
            color: (isnew === 'true' ? true : false)
                ? theme.palette.cardSubtitle.main
                : approvalstatus === ApprovalStatuses.NoReviewRequired
                ? 'white'
                : theme.palette.cardSubtitle.main
        }
    })
);

export {
    StyledButtonApprove,
    StyledButtonDeny,
    StyledButtonPartialApprove,
    StyledButtonNoReviewRequired
};
